module.exports = __webpack_public_path__ + "img/logo-prestige@3x.png";